export enum EvaluationResultsStatus {
  success = "success",
  failed = "failed",
  evaluating = "processing",
  processing = "processing",
}
